/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "pl": {
        "nu": ["latn"],
        "year": {
          "0": "w tym roku",
          "1": "w przyszłym roku",
          "future": {
            "one": "za {0} rok",
            "few": "za {0} lata",
            "many": "za {0} lat",
            "other": "za {0} roku"
          },
          "past": {
            "one": "{0} rok temu",
            "few": "{0} lata temu",
            "many": "{0} lat temu",
            "other": "{0} roku temu"
          },
          "-1": "w zeszłym roku"
        },
        "year-short": {
          "0": "w tym roku",
          "1": "w przyszłym roku",
          "future": {
            "one": "za {0} rok",
            "few": "za {0} lata",
            "many": "za {0} lat",
            "other": "za {0} roku"
          },
          "past": {
            "one": "{0} rok temu",
            "few": "{0} lata temu",
            "many": "{0} lat temu",
            "other": "{0} roku temu"
          },
          "-1": "w zeszłym roku"
        },
        "year-narrow": {
          "0": "w tym roku",
          "1": "w przyszłym roku",
          "future": {
            "one": "za {0} rok",
            "few": "za {0} lata",
            "many": "za {0} lat",
            "other": "za {0} roku"
          },
          "past": {
            "one": "{0} rok temu",
            "few": "{0} lata temu",
            "many": "{0} lat temu",
            "other": "{0} roku temu"
          },
          "-1": "w zeszłym roku"
        },
        "quarter": {
          "0": "w tym kwartale",
          "1": "w przyszłym kwartale",
          "future": {
            "one": "za {0} kwartał",
            "few": "za {0} kwartały",
            "many": "za {0} kwartałów",
            "other": "za {0} kwartału"
          },
          "past": {
            "one": "{0} kwartał temu",
            "few": "{0} kwartały temu",
            "many": "{0} kwartałów temu",
            "other": "{0} kwartału temu"
          },
          "-1": "w zeszłym kwartale"
        },
        "quarter-short": {
          "0": "w tym kwartale",
          "1": "w przyszłym kwartale",
          "future": {
            "one": "za {0} kw.",
            "few": "za {0} kw.",
            "many": "za {0} kw.",
            "other": "za {0} kw."
          },
          "past": {
            "one": "{0} kw. temu",
            "few": "{0} kw. temu",
            "many": "{0} kw. temu",
            "other": "{0} kw. temu"
          },
          "-1": "w zeszłym kwartale"
        },
        "quarter-narrow": {
          "0": "w tym kwartale",
          "1": "w przyszłym kwartale",
          "future": {
            "one": "za {0} kw.",
            "few": "za {0} kw.",
            "many": "za {0} kw.",
            "other": "za {0} kw."
          },
          "past": {
            "one": "{0} kw. temu",
            "few": "{0} kw. temu",
            "many": "{0} kw. temu",
            "other": "{0} kw. temu"
          },
          "-1": "w zeszłym kwartale"
        },
        "month": {
          "0": "w tym miesiącu",
          "1": "w przyszłym miesiącu",
          "future": {
            "one": "za {0} miesiąc",
            "few": "za {0} miesiące",
            "many": "za {0} miesięcy",
            "other": "za {0} miesiąca"
          },
          "past": {
            "one": "{0} miesiąc temu",
            "few": "{0} miesiące temu",
            "many": "{0} miesięcy temu",
            "other": "{0} miesiąca temu"
          },
          "-1": "w zeszłym miesiącu"
        },
        "month-short": {
          "0": "w tym mies.",
          "1": "w przyszłym mies.",
          "future": {
            "one": "za {0} mies.",
            "few": "za {0} mies.",
            "many": "za {0} mies.",
            "other": "za {0} mies."
          },
          "past": {
            "one": "{0} mies. temu",
            "few": "{0} mies. temu",
            "many": "{0} mies. temu",
            "other": "{0} mies. temu"
          },
          "-1": "w zeszłym mies."
        },
        "month-narrow": {
          "0": "w tym mies.",
          "1": "w przyszłym mies.",
          "future": {
            "one": "za {0} mies.",
            "few": "za {0} mies.",
            "many": "za {0} mies.",
            "other": "za {0} mies."
          },
          "past": {
            "one": "{0} mies. temu",
            "few": "{0} mies. temu",
            "many": "{0} mies. temu",
            "other": "{0} mies. temu"
          },
          "-1": "w zeszłym mies."
        },
        "week": {
          "0": "w tym tygodniu",
          "1": "w przyszłym tygodniu",
          "future": {
            "one": "za {0} tydzień",
            "few": "za {0} tygodnie",
            "many": "za {0} tygodni",
            "other": "za {0} tygodnia"
          },
          "past": {
            "one": "{0} tydzień temu",
            "few": "{0} tygodnie temu",
            "many": "{0} tygodni temu",
            "other": "{0} tygodnia temu"
          },
          "-1": "w zeszłym tygodniu"
        },
        "week-short": {
          "0": "w tym tyg.",
          "1": "w przyszłym tyg.",
          "future": {
            "one": "za {0} tydz.",
            "few": "za {0} tyg.",
            "many": "za {0} tyg.",
            "other": "za {0} tyg."
          },
          "past": {
            "one": "{0} tydz. temu",
            "few": "{0} tyg. temu",
            "many": "{0} tyg. temu",
            "other": "{0} tyg. temu"
          },
          "-1": "w zeszłym tyg."
        },
        "week-narrow": {
          "0": "w tym tyg.",
          "1": "w przyszłym tyg.",
          "future": {
            "one": "za {0} tydz.",
            "few": "za {0} tyg.",
            "many": "za {0} tyg.",
            "other": "za {0} tyg."
          },
          "past": {
            "one": "{0} tydz. temu",
            "few": "{0} tyg. temu",
            "many": "{0} tyg. temu",
            "other": "{0} tyg. temu"
          },
          "-1": "w zeszłym tyg."
        },
        "day": {
          "0": "dzisiaj",
          "1": "jutro",
          "2": "pojutrze",
          "future": {
            "one": "za {0} dzień",
            "few": "za {0} dni",
            "many": "za {0} dni",
            "other": "za {0} dnia"
          },
          "past": {
            "one": "{0} dzień temu",
            "few": "{0} dni temu",
            "many": "{0} dni temu",
            "other": "{0} dnia temu"
          },
          "-2": "przedwczoraj",
          "-1": "wczoraj"
        },
        "day-short": {
          "0": "dzisiaj",
          "1": "jutro",
          "2": "pojutrze",
          "future": {
            "one": "za {0} dzień",
            "few": "za {0} dni",
            "many": "za {0} dni",
            "other": "za {0} dnia"
          },
          "past": {
            "one": "{0} dzień temu",
            "few": "{0} dni temu",
            "many": "{0} dni temu",
            "other": "{0} dnia temu"
          },
          "-2": "przedwczoraj",
          "-1": "wczoraj"
        },
        "day-narrow": {
          "0": "dziś",
          "1": "jutro",
          "2": "pojutrze",
          "future": {
            "one": "za {0} dzień",
            "few": "za {0} dni",
            "many": "za {0} dni",
            "other": "za {0} dnia"
          },
          "past": {
            "one": "{0} dzień temu",
            "few": "{0} dni temu",
            "many": "{0} dni temu",
            "other": "{0} dnia temu"
          },
          "-2": "przedwczoraj",
          "-1": "wcz."
        },
        "hour": {
          "0": "ta godzina",
          "future": {
            "one": "za {0} godzinę",
            "few": "za {0} godziny",
            "many": "za {0} godzin",
            "other": "za {0} godziny"
          },
          "past": {
            "one": "{0} godzinę temu",
            "few": "{0} godziny temu",
            "many": "{0} godzin temu",
            "other": "{0} godziny temu"
          }
        },
        "hour-short": {
          "0": "ta godzina",
          "future": {
            "one": "za {0} godz.",
            "few": "za {0} godz.",
            "many": "za {0} godz.",
            "other": "za {0} godz."
          },
          "past": {
            "one": "{0} godz. temu",
            "few": "{0} godz. temu",
            "many": "{0} godz. temu",
            "other": "{0} godz. temu"
          }
        },
        "hour-narrow": {
          "0": "ta godzina",
          "future": {
            "one": "za {0} g.",
            "few": "za {0} g.",
            "many": "za {0} g.",
            "other": "za {0} g."
          },
          "past": {
            "one": "{0} g. temu",
            "few": "{0} g. temu",
            "many": "{0} g. temu",
            "other": "{0} g. temu"
          }
        },
        "minute": {
          "0": "ta minuta",
          "future": {
            "one": "za {0} minutę",
            "few": "za {0} minuty",
            "many": "za {0} minut",
            "other": "za {0} minuty"
          },
          "past": {
            "one": "{0} minutę temu",
            "few": "{0} minuty temu",
            "many": "{0} minut temu",
            "other": "{0} minuty temu"
          }
        },
        "minute-short": {
          "0": "ta minuta",
          "future": {
            "one": "za {0} min",
            "few": "za {0} min",
            "many": "za {0} min",
            "other": "za {0} min"
          },
          "past": {
            "one": "{0} min temu",
            "few": "{0} min temu",
            "many": "{0} min temu",
            "other": "{0} min temu"
          }
        },
        "minute-narrow": {
          "0": "ta minuta",
          "future": {
            "one": "za {0} min",
            "few": "za {0} min",
            "many": "za {0} min",
            "other": "za {0} min"
          },
          "past": {
            "one": "{0} min temu",
            "few": "{0} min temu",
            "many": "{0} min temu",
            "other": "{0} min temu"
          }
        },
        "second": {
          "0": "teraz",
          "future": {
            "one": "za {0} sekundę",
            "few": "za {0} sekundy",
            "many": "za {0} sekund",
            "other": "za {0} sekundy"
          },
          "past": {
            "one": "{0} sekundę temu",
            "few": "{0} sekundy temu",
            "many": "{0} sekund temu",
            "other": "{0} sekundy temu"
          }
        },
        "second-short": {
          "0": "teraz",
          "future": {
            "one": "za {0} sek.",
            "few": "za {0} sek.",
            "many": "za {0} sek.",
            "other": "za {0} sek."
          },
          "past": {
            "one": "{0} sek. temu",
            "few": "{0} sek. temu",
            "many": "{0} sek. temu",
            "other": "{0} sek. temu"
          }
        },
        "second-narrow": {
          "0": "teraz",
          "future": {
            "one": "za {0} s",
            "few": "za {0} s",
            "many": "za {0} s",
            "other": "za {0} s"
          },
          "past": {
            "one": "{0} s temu",
            "few": "{0} s temu",
            "many": "{0} s temu",
            "other": "{0} s temu"
          }
        }
      }
    },
    "availableLocales": ["pl"]
  });
}